import styled from '@emotion/styled';

import theme, { AppTheme } from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';
import Table from '@app/shop/components/Table';
import Card from '@app/components/Card';

export const ReviewTable = styled(Table)`
  background-color: ${({ theme }) => (theme as AppTheme).colors.nearWhite};
  table-layout: auto;
  margin-top: ${rem(25)};
  border-radius: ${({ theme }) => (theme as AppTheme).radii.normal};
  box-shadow: 0px 1px 3px #cfdde6;

  & tbody {
    & th {
      font-weight: normal;
      border: none;
      text-align: left;
    }

    & td {
      border: none;
      text-align: right;
    }

    & [data-table='review-subtotal'] th,
    & [data-table='review-total'] th {
      font-weight: bold;
    }

    & [data-table='review-subtotal'] {
      & td,
      & th {
        border-bottom: 1px solid ${theme.colors.lightGray};
      }
    }

    & [data-table='review-total'] {
      & td,
      & th {
        border-top: 1px solid ${theme.colors.lightGray};
      }
    }
  }

  & thead {
    & th:not(:first-of-type) {
      text-align: right;
    }
  }
`;

ReviewTable.defaultProps = { alternateRows: false };

export const AddressCard = styled(Card)`
  width: 48%;

  & span:first-of-type {
    padding-bottom: ${rem(8)};
    font-weight: bold;
  }
`;

export const ShippingCard = styled(Card)`
  width: 100%;
  margin-top: ${rem(24)};

  & span:first-of-type {
    padding-bottom: ${rem(8)};
    font-weight: bold;
  }
`;

export const Error = styled.p`
  color: ${theme.colors.red};
  margin-block-end: ${rem(5)};
`;
